import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import { personalDetails } from "../Details";

function Home() {
  const { name, tagline, img } = personalDetails;
  const h11 = useRef();
  const h12 = useRef();
  const h13 = useRef();
  const myimageref = useRef();
  useEffect(() => {
    const tl = gsap.timeline();
    tl.from(
      h11.current,
      {
        x: "-100%",
        delay: 0.8,
        opacity: 0,
        duration: 2,
        ease: "Power3.easeOut",
      },
      "<"
    )
      .from(
        h12.current,
        {
          x: "-100%",
          delay: 0.5,
          opacity: 0,
          duration: 2,
          ease: "Power3.easeOut",
        },
        "<"
      )
      .from(
        h13.current,
        {
          x: "-100%",
          delay: 0.1,
          opacity: 0,
          duration: 2,
          ease: "Power3.easeOut",
        },
        "<"
      )
      .from(
        myimageref.current,
        {
          x: "200%",
          delay: 0.5,
          opacity: 0,
          duration: 2,
          ease: "Power3.easeOut",
        },
        "<"
      );
  }, []);

  return (
    
    <main className="container mx-auto max-width section md:flex justify-between items-center">
      <div>
        <h1
          ref={h11}
          className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold"
        >
          Hi,👋<br></br>this is<br></br>
        </h1>
        <h1
          ref={h12}
          className="text-2xl bg-clip-text bg-gradient text-transparent md:text-4xl xl:text-5xl xl:leading-tight font-bold"
        >
          {name}
        </h1>
        <h2
          ref={h13}
          className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold"
        >
          {tagline}
        </h2>
        <a href="/resume.pdf" target="_blank" rel="noopener noreferrer" style={{ color: 'White', textDecoration: 'underline' }}>View my resume</a>
        
         
      </div>
      <div>
      {/* <a href="" onClick={(e) => { e.preventDefault(); Calendly.initPopupWidget({ url: 'https://calendly.com/subhashnandhakumar311/30min' }); }}>Schedule time with me</a> */}
      {/* <PopupButton
        url="https://calendly.com/subhashnandhakumar311/30min" 
        rootElement={document.getElementById("root")}
        text="Click here to schedule!"
      /> */}

    {/* <PopupWidget
        url="https://calendly.com/subhashnandhakumar311/30min"
        rootElement={document.getElementById("root")}
        text="Discuss with me!"
        textColor="#ffffff"
        color="#00a2ff"
      /> */}
      
      </div>
      <div className="mt-5 md:mt-0">
        <img ref={myimageref} className="w-1/2 md:ml-auto" src={img} alt="Subhash Nandhakumar" />
      </div>
    </main>
  );
}

export default Home;
